import { useEffect, useMemo } from 'react'
import {
  generatePath,
  Redirect,
  Route,
  Switch,
  useRouteMatch,
} from 'react-router-dom'
import { useIntl } from 'react-intl'

import { H2 } from 'components/Typography/Headings'
import { subscriptionManagementMessages } from './messages'
//import SubsManageRightPanel from './SubsManageRightPanel'
import CheckoutDetailsBlock from '../SubscriptionManagement/CheckoutDetailsBlock'
import {
  SUBS_MANAGE_ADD_CARD_ROUTE,
  SUBS_MANAGE_SUCCESS_ROUTE,
  SUBS_MANAGE_UPGRADE_ROUTE,
} from '../consts'
import AddCard from './AddCard'
import UpgradeSubscription from './UpgradeSubscription'
//import routes from 'app/routes'
import { useAppDispatch, useAppSelector } from 'app/hooks'

import { useHomeRouteParams } from 'features/home/hooks'
import { subscriptionHomePriceSelector } from 'features/home/selectors'
import { currentUserSelector } from 'features/auth/login/selectors'
import { SpinnerCentered } from 'components/Loader'
import {
  SubsManageContainer,
  SubsManageBody,
  SubsManageLeftPanelContainer,
} from './styles'
import {
  getPaymentMethodsListActions,
  getPaymentMethodsListThunk,
} from 'features/paymentMethods/slice'
//import { getHomeSubscriptonInfo } from 'features/home/utils'
//import { selectedHomeSelector } from 'features/home/selectors'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import SubscriptionCheckoutSuccess from '../SubscriptionCheckoutSuccess'
import ROUTES from 'app/routes'
import {
  fetchHomeSubscriptionPriceThunk,
  subscriptionHomePriceActions,
} from '../SubscriptionDetails/slice'

function SubscriptionManagement() {
  const dispatch = useAppDispatch()
  const { path } = useRouteMatch()
  const { homeId } = useHomeRouteParams()
  const { formatMessage } = useIntl()
  //const history = useHistory()

  const rootId = useAppSelector(currentRootDomainIdSelector)
  const pricesAreFetching = useAppSelector(
    subscriptionHomePriceSelector.isFetching
  )
  const pricesAreLoaded = useAppSelector(
    subscriptionHomePriceSelector.isFinished
  )
  const user = useAppSelector(currentUserSelector)

  //const home = useAppSelector(selectedHomeSelector.data)
  //const subscriptionInfo = getHomeSubscriptonInfo(home)

  const isLoaded = !pricesAreFetching && pricesAreLoaded

  const redirectPath = useMemo(
    () =>
      generatePath(ROUTES.homeSubscription.root(), {
        rootDomainId: rootId || '',
        homeId,
      }),
    [homeId, rootId]
  )

  /*
  useEffect(() => {
    if (subscriptionInfo?.autoRenew) {
      if (rootId) {
        const homeStatusPath = generatePath(routes.homeStatus, {
          homeId,
          rootDomainId: rootId,
        })
        history.push(homeStatusPath)
      }
    }
  }, [subscriptionInfo, history, homeId, rootId])
*/

  useEffect(() => {
    if (homeId && user.id && rootId) {
      dispatch(fetchHomeSubscriptionPriceThunk(homeId))
      dispatch(getPaymentMethodsListThunk(rootId))
    }

    return () => {
      dispatch(subscriptionHomePriceActions.clear())
      dispatch(getPaymentMethodsListActions.clear())
    }
  }, [dispatch, homeId, rootId, user.id])
  return (
    <SubsManageContainer>
      <H2>{formatMessage(subscriptionManagementMessages.title)}</H2>
      {isLoaded ? (
        <>
          <SubsManageBody>
            <SubsManageLeftPanelContainer>
              <Switch>
                <Route
                  exact
                  path={`${path}/${SUBS_MANAGE_ADD_CARD_ROUTE}`}
                  component={AddCard}
                />
                <Route
                  exact
                  path={`${path}/${SUBS_MANAGE_UPGRADE_ROUTE}`}
                  component={UpgradeSubscription}
                />
                <Route
                  exact
                  path={`${path}/${SUBS_MANAGE_SUCCESS_ROUTE}`}
                  component={SubscriptionCheckoutSuccess}
                />
                <Route path="*">
                  <Redirect to={redirectPath} />
                </Route>
              </Switch>
            </SubsManageLeftPanelContainer>
            <CheckoutDetailsBlock />
          </SubsManageBody>
        </>
      ) : (
        <SpinnerCentered />
      )}
    </SubsManageContainer>
  )
}

export default SubscriptionManagement
